import {useEffect, useState} from 'react';

const MOBILE_REGEX = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;

const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof navigator === 'undefined') return;
    setIsMobile(MOBILE_REGEX.test(navigator.userAgent));
  }, []);

  return isMobile;
};

export default useIsMobile;
